import { avatar } from '../Styles'

export const AvatarField = ({ record, source }) => (
  <img src="Avatar.jpg" style={{ ...avatar.small }} alt="" />
);